import {
  Directive, Input, Output, EventEmitter,
  HostListener, HostBinding, ContentChild,
} from '@angular/core';
import { DownArrowIconDirective } from 'shared/icon/down-arrow-icon.directive';


@Directive({
  selector: '[collapseHeader]',
  exportAs: 'collapse-header'
})
export class CollapseHeaderDirective {
  @Input() enabled: boolean = true;

  @Output() changeCollapse: EventEmitter<any> = new EventEmitter<any>();

  @HostBinding('class.expanded')
  @Input() expanded: boolean = false;

  @HostBinding('class.disabled') get disabled() {
    return !this.enabled;
  }

  @HostBinding('class.bgcolor-lightergrey')
  @Input() grey: boolean = false;

  @HostBinding('class.has-error')
  @Input() hasError: boolean = false;

  @HostBinding('class.collapse-header') isCollapseHeaderClass = true;

  @HostListener('click') onClick() {
    if (this.enabled) {
      this.changeCollapse.emit();
    }
  }

  public toggle() {
    this.expanded = !this.expanded;
  }

  public setCollapsed(collapsed: boolean = false) {
    this.expanded = !collapsed;
  }

  public setEnabled(enabled: boolean) {
    this.enabled = enabled;
  }
}
